import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
const Analytics = () => {
  const loc = useLocation();

  useEffect(() => {
    ReactGA.event("pageview", {
      page: { path: loc.pathname },
    });
  }, [loc]);
  return <></>;
};

export default Analytics;
